import { render } from "./AutoComplete.vue?vue&type=template&id=965522bc&scoped=true"
import script from "./AutoComplete.vue?vue&type=script&lang=ts"
export * from "./AutoComplete.vue?vue&type=script&lang=ts"

import "./AutoComplete.vue?vue&type=style&index=0&id=965522bc&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-965522bc"

export default script